module.exports = __webpack_public_path__ + "static/media/telephone_book2.174c61f9.png";